import { useQuery } from "@tanstack/react-query";
import { default as Axios } from 'axios';

const axiosClient = Axios.create({
	baseURL: '/',
	headers: {
		'Content-Type': 'application/json',
		'Cache-Control': 'no-cache',
		'Pragma': 'no-cache',
		'Expires': '0'
	}
});

axiosClient.interceptors.response.use(
	(response) => {
		return response.data;
	});

export interface BuildInformation {
	buildNumber: number
}

export const useGetBuildInformation = () => {

	const { data } = useQuery({
		queryKey: ['build-info'],
		queryFn: async () => await axiosClient.get('build-information.json') as BuildInformation,
		refetchInterval: 300000,
		refetchOnWindowFocus: 'always'
	});

	return {
		data
	};
};

